import { DataAction, ErrorAction, PendingAction } from 'types/services/redux-action';
import manageError from 'utils/logging/manageError';

export const ACTION_PENDING = 'ACTION_PENDING';

export const ACTION_COMPLETE = 'ACTION_COMPLETE';

export const ACTION_ERROR = 'ACTION_ERROR';

export const CLEAN_ERROR = 'CLEAN_ERROR';

const IGNORE_ERROR: unknown[] = [400, 404];

/* NOTE: Those are some generic action creators for handling the three diferent stages of an asyn request
         - pending
         - completed
         - error

    In the type param, is initiated as default wuth some pre-defined Action Types because of legacy code
*/
export const actionPending = <T extends string>(type: T, pending?: boolean): PendingAction<T> => ({
  type,
  pending,
});

export const actionComplete = <T extends string, D>(type: T, data?: D): DataAction<T, D> => ({
  type,
  data,
});

export const actionError = <T extends string, E = unknown>(type: T, error?: E): ErrorAction<T, E> => {
  if (!IGNORE_ERROR.includes(error)) {
    manageError(error, { type });
  }

  return {
    type,
    error,
  };
};

/* CLEAN ERROR */

export const cleanError = () => ({
  type: CLEAN_ERROR,
});
